import { E as r } from "./profileEnums-fde613bf.mjs";
const o = {
  SelfInitiatedFlow: "selfInitiatedFlow",
  SelfInitiatedFlowV2: "selfInitiatedFlowV2",
  ShareBarFlow: "shareBarFlow",
  CoApplicantFlow: "coApplicantFlow",
  ManualRenewalFlow: "manualRenewalFlow",
  UpgradeFlow: "upgradeFlow",
  DowngradeFlow: "downgradeFlow",
  AutoRenewSignUpFlow: "autoRenewSignUpFlow",
  ProductUserFlow: "productUserFlow",
  AboLedFlow: "aboLedFlow",
  SelfInitiatedFlowMultiStep: "selfInitiatedFlowMultiStep",
  GuestCheckoutFlow: "guestCheckoutFlow",
  OpsLedFlow: "opsLedFlow",
  SelfInitiatedMobileFlow: "selfInitiatedMobileFlow"
}, n = {
  ID_NUMBER_MIN: 2,
  ID_NUMBER_MAX: 10,
  NAME_MIN: 2,
  NAME_MAX: 100,
  CONTACT_NICKNAME_MAX: 50,
  ADDRESS_LINE_MAX: 100,
  POSTCODE_MIN: 5,
  POSTCODE_MAX: 5,
  BIRTHDAY_AGE_MIN: 10,
  CID_MIN: 7,
  CID_MAX: 13,
  MAX_AGE: 110
}, s = {
  BAD_REQUEST: "BAD_REQUEST"
}, l = {
  GENERAL_ERROR_CODE: "invalid-registration",
  GENERAL_LOADING_ERROR_CODE: "data-loading-error",
  SPONSOR_FAILED: "comregistrationas-sponsor-validation-failed",
  SPONSOR_BLOCK_VALIDATION_ERROR: "SPONSOR_BLOCK_VALIDATION_ERROR",
  PROFILE_GENERAL_ERROR_CODE: "general",
  CID_EXPIRED_CODE: "comregistrationas-cid-expired",
  EMAIL_NOT_UNIQUE: "comprofileas-email-not-unique",
  PHONE_NOT_UNIQUE: "comprofileas-phone-not-unique",
  ACCOUNT_EMAIL_NOT_UNIQUE: "comaccountas-email-not-unique",
  ACCOUNT_PHONE_NOT_UNIQUE: "comaccountas-phone-not-unique",
  REGISTRATION_INTERNAL_SERVER_ERROR: "comregistrationas-internal-server-error"
}, R = {
  STATUS_503: 503,
  STATUS_504: 504
}, d = {
  FULL: "FULL",
  DOCUMENTS: "DOCUMENTS"
}, _ = {
  RENEWAL_CONFIG: "renewal",
  ALLOW_RENEWAL: "allowRenewal",
  ALLOW_UPGRADE: "allowUpgrade",
  ALLOW_DOWNGRADE: "allowDowngrade",
  ALLOW_AUTO_RENEWAL: "allowAutoRenewal",
  USE_PROFILE_CART: "useProfileCart",
  RENEWAL_GRACE_PERIOD: "renewalGracePeriodMonths",
  RENEWAL_WINDOW_PERIOD: "renewalWindowPeriodMonths"
}, A = {
  E_KIT: "eKit",
  P_KIT: "pKit"
}, c = {
  BUSINESS_OWNER: "abo",
  MEMBER: "member"
}, T = {
  ERROR_IMAGE: "/images/CheckoutPageError.svg",
  NO_RESULT_IMAGE: "/images/OrderHistoryEmptyResult.svg",
  STARTER_KIT_IMAGE: "icons/AmwayActive.svg"
}, C = {
  GLOBAL_QA: "global-qa",
  GLOBAL_DEV: "global-dev",
  THA_PROD: "tha-prod",
  THA_UAT: "tha-uat",
  THA_QA: "tha-qa"
}, g = "en", a = 90, I = {
  // (w/h)
  CID: 1.602 / 1,
  //width is more than length
  HOUSE_REGISTRATION: 0.871 / 1,
  PASSPORT: 1 / 1.41
}, O = {
  scale: 1,
  rotate: 0,
  slideRotation: a,
  borderRadius: 0,
  height: 200,
  width: 200
}, D = 360, S = {
  USER_PASSPORT: "personalIdPassportRecordNumber",
  USER_CID: "personalIdCidRecordNumber",
  SPOUSE_CID: "spouseCidRecordNumber",
  SPOUSE_PASSPORT: "spousePassportRecordNumber"
}, p = {
  ADDRESS_LINE_ONE: "addrLineOne",
  ADDRESS_LINE_TWO: "addrLineTwo",
  ADDRESS_LINE_THREE: "addrLineThree",
  // LATAM
  ADDRESS_TYPE_OTHER: "addressTypeOther",
  MAIN_ROAD: "mainRoad",
  SIDE_LINE: "sideLine",
  NUMBER: "number",
  CONTACT_NICKNAME: "contactNickname",
  RECIPIENT_FIRST_NAME: "recipientFirstName",
  RECIPIENT_LAST_NAME: "recipientLastName",
  DELIVERY_INSTRUCTIONS: "deliveryInstructions",
  // GUIDED INPUT
  STATE: "state",
  DISTRICT: "district",
  SUB_DISTRICT: "subDistrict",
  POSTAL_CODE: "postalCode",
  ADDRESS_TYPE: "addressType",
  // OTHER FIELD
  COUNTRY_CODE: "countryCode",
  // SHIPPING
  SHIPPING_DETAILS: "shipping-details"
}, N = {
  UPLOAD: "upload",
  SIGNATURE: "signature"
}, L = {
  headline: "profile.ApiErrorModal.genericError.headline",
  body: "profile.ApiErrorModal.genericError.body"
}, m = {
  IMAGE_MAX_SIZE: 6 * 1024 * 1024,
  IMAGE_HEIGHT: 140,
  IMAGE_WIDTH: 240,
  TIME_COVERSION: 1e3 * 3600 * 24,
  VALID_FILE_TYPES: ["image/jpeg", "image/png"]
}, M = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/, u = /^[0-9]+$/, f = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, P = {
  "comregistrationas-submit-validation-error": {
    title: "profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle",
    desc: "profile.ErrorCard.RegErrorCardConfig.someThingWentWrongDesc",
    primaryButtonLabel: "profile.ErrorCard.RegErrorCardConfig.goToHomePageButton",
    primaryRedirectUrl: r.HOME
  },
  "comregistrationas-unknown-error": {
    title: "profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle",
    primaryButtonLabel: "profile.ErrorCard.RegErrorCardConfig.goToHomePageButton",
    primaryRedirectUrl: r.HOME
  },
  "comregistrationas-blacklist-error": {
    title: "profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle",
    desc: "profile.ErrorCard.RegErrorCardConfig.blackListDesc",
    primaryButtonLabel: "profile.ErrorCard.RegErrorCardConfig.goToHomePageButton",
    primaryRedirectUrl: r.HOME
  },
  "comregistrationas-account-already-exists": {
    title: "profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle",
    desc: "profile.ErrorCard.RegErrorCardConfig.accountAlreadyExistDesc",
    primaryButtonLabel: "profile.ErrorCard.RegErrorCardConfig.goToHomePageButton",
    primaryRedirectUrl: r.HOME
  },
  "comregistrations-cooling-period-error": {
    title: "profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle",
    desc: "profile.ErrorCard.RegErrorCardConfig.coolingPeriodDesc",
    primaryButtonLabel: "profile.ErrorCard.RegErrorCardConfig.goToHomePageButton",
    primaryRedirectUrl: r.HOME
  },
  "comregistrationas-account-exists": {
    title: "profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle",
    desc: "profile.ErrorCard.RegErrorCardConfig.accountExistDesc",
    primaryButtonLabel: "profile.ErrorCard.RegErrorCardConfig.goToHomePageButton",
    primaryRedirectUrl: r.HOME
  },
  "comregistrationas-internal-server-error": {
    title: "profile.ErrorCard.RegErrorCardConfig.someThingWentWrongTitle",
    primaryButtonLabel: "profile.ErrorCard.RegErrorCardConfig.goToHomePageButton",
    primaryRedirectUrl: r.HOME
  },
  default: {
    title: "profile.common.errorHeading",
    desc: "profile.common.pleaseTryAgain",
    primaryButtonLabel: "profile.ErrorCard.RegErrorCardConfig.goToHomePageButton",
    primaryRedirectUrl: r.HOME
  }
}, U = {
  "YYYY-MM-DD": "YYYY-MM-DD",
  "MM/DD/YYYY": "MM/DD/YYYY",
  "DD/MM/YYYY": "DD/MM/YYYY"
}, t = [
  "personalIdType",
  "personalIdRecordNumber",
  "firstName",
  "lastName",
  "taxRegime",
  "citizenshipCountry",
  "email",
  "phone",
  "termsAndConditionCheckbox",
  "gender",
  "birthDate",
  "password",
  "sponsor"
], i = [
  // other subForm fields
  ...t,
  "billingAddress",
  "personalIdDocument"
], w = {
  [o.AboLedFlow]: i.filter((e) => e != "password")
}, F = [o.AboLedFlow, o.ShareBarFlow], b = "downlineRegisrationFlow", h = "Random", y = "VALID";
export {
  A,
  m as C,
  U as D,
  l as E,
  S as M,
  u as N,
  d as P,
  P as R,
  F as S,
  n as T,
  i as U,
  y as V,
  s as a,
  L as b,
  b as c,
  c as d,
  h as e,
  T as f,
  O as g,
  I as h,
  a as i,
  D as j,
  w as k,
  N as l,
  p as m,
  _ as n,
  R as o,
  g as p,
  M as q,
  C as r,
  f as s,
  o as t,
  t as u
};
//# sourceMappingURL=Constants-72ad2288.mjs.map
